import { useContext } from 'react';
import { ChatResponseType } from '@trinity/chat';
import { FRMAccountSearchMessage, RepTerritoryInsights } from '@trinity/custom-pages-registry';
import { ChatMarkdown } from '../Markdown/Markdown';
import {
  ChatHintsLoadingContext,
  ChatInitialResponseContext,
} from './context';
import { HcpSearchResponse } from './Message.Response.HcpSearch';
import { BasicSystemUserMessage } from './Message.System.Basic';
import { SystemUserPlaceholderMessage } from './Message.System.Placeholder';

export const InitialSystemMessage = () => {
  const response = useContext(ChatInitialResponseContext);
  const loading = useContext(ChatHintsLoadingContext);

  if (loading || !response) {
    return <SystemUserPlaceholderMessage />;
  }

  if (response.type === ChatResponseType.HcpSearch) {
    return <HcpSearchResponse />;
  }

  if (response.type === ChatResponseType.FrmAccountSearch) {
    return (
      <BasicSystemUserMessage>
        <FRMAccountSearchMessage />
      </BasicSystemUserMessage>
    );
  }

  if (response.type === ChatResponseType.RepTerritoryInsights) {
    return (
      <BasicSystemUserMessage>
        <RepTerritoryInsights />
      </BasicSystemUserMessage>
    );
  }

  if (response.type === ChatResponseType.Markdown) {
    return (
      <BasicSystemUserMessage>
        <ChatMarkdown value={response.value} />
      </BasicSystemUserMessage>
    );
  }

  const responseHints = response.type === ChatResponseType.InitialGreeting ? response.data.hints : [];

  return (
    <BasicSystemUserMessage hints={responseHints}>
      <ChatMarkdown value={response.value} />
    </BasicSystemUserMessage>
  );
};
